import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function LearnMore({ to = "/servizi", children = "Clicca qui per saperne di più", testid }) {
  return (
    <Link
      to={to}
      data-testid={testid || "learn-more"}
      className="group inline-flex items-center gap-2 rounded-full bg-teal text-white font-semibold text-sm px-6 py-3.5 shadow-soft hover:bg-teal-deep hover:shadow-lift hover:-translate-y-0.5 transition-all duration-300"
    >
      Clicca qui per saperne di più
      <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
    </Link>
  );
}